import { Injectable } from '@angular/core';
import { AuthenticationService } from '@charlesschwab/sac-ui-core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthWrapperService {
    externalToken: Observable<string>;
    constructor(private readonly authService: AuthenticationService) {

    }

    getToken(): string {
      return this.authService.externalAccessToken;
    }
}
